import { AuthRoutes } from 'src/modules/Auth/routes';
import { OrderManagementRoutes } from 'src/modules/OrderManagement/routes';
import { FinanceRoutes } from 'src/modules/Finance/routes';
import { CustomerManagementRoutes } from 'src/modules/CustomerManagement/routes';
import { HomeRoutes } from 'src/modules/Home/routes';
import { ShopRoutes } from 'src/modules/Shop/routes';
import { CatalogRoutes } from 'src/modules/Catalog/routes';
import { CatalogV2Routes } from 'src/modules/CatalogV2/routes';
import { DocumentationRoutes } from 'src/modules/Documentation/routes';

export const AppRoutes = [].concat(
  CatalogRoutes,
  CatalogV2Routes,
  CustomerManagementRoutes,
  OrderManagementRoutes,
  FinanceRoutes,
  ShopRoutes,
  HomeRoutes,
  AuthRoutes,
  DocumentationRoutes,
);
